var _style, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSelectCheck(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u5716\\u5C64_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 20 17",
    style: {
      enableBackground: "new 0 0 20 17"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, " .st0{fill-rule:evenodd;clip-rule:evenodd;fill:#ffdf1a;} ")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M0,17h20V0L0,17z M17.6,10l-4.4,4.4c-0.1,0.1-0.3,0.1-0.6,0l-2.5-2.5c-0.1-0.2-0.1-0.3,0-0.6l0.6-0.6 c0.1-0.1,0.3-0.1,0.5,0l1.7,1.7l3.6-3.6c0.1-0.2,0.3-0.2,0.6,0l0.6,0.6C17.8,9.7,17.7,9.8,17.6,10z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelectCheck);
export default __webpack_public_path__ + "static/media/select-check.ce578ddd4641ad55ce5a4b9cc433fa09.svg";
export { ForwardRef as ReactComponent };